import React from 'react';
import ReactDOM from 'react-dom';
import './global.css';
import 'react-notifications/lib/notifications.css';
import App from './App';

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById('root')
);
